module.exports = __webpack_public_path__ + "img/mailchimpv3.1a56dfc6.png";